import React from "react";
import dayjs from "dayjs";

import { zodResolver } from "@hookform/resolvers/zod";
import { Controller, useForm } from "react-hook-form";

import Button from "../../themed/button";
import Input from "../../themed/input/input";

import { CDRReportNumber, cdrReportNumber } from "./schema";

interface Props {
    reportNumber: string;
    onSaveReportNumber: (reportNumber: string) => void;
}

const CDRReportNumberForm: React.FC<Props> = ({ reportNumber, onSaveReportNumber }) => {
    const { control, formState, handleSubmit } = useForm<CDRReportNumber>({
        resolver: zodResolver(cdrReportNumber),
        defaultValues: {
            cdrReportNumber: reportNumber,
        },
    });

    const generateReportNumber = (data: CDRReportNumber) => {
        const reportNumber = `CDR-${data.cdrReportNumber}-${dayjs().year()}`;
        onSaveReportNumber(reportNumber);
    };

    return ( 
        <form onSubmit={handleSubmit((data) => generateReportNumber(data))}>
            <Controller
                control={control}
                name="cdrReportNumber"
                render={({ field }) => (
                    <div className="d-flex justify-content-start align-items-center">
                        <Input
                            type="text"
                            label="CDR Report Number Year Prefix"
                            value="CDR"
                            disabled
                        />
        
                        <div className="ms-3 me-3">
                            <Input
                                type="text"
                                label="CDR Report Number"
                                placeholder="Enter CDR ReportNumber"
                                value={field.value}
                                onChange={field.onChange}
                                name={field.name}
                                error={formState.errors.cdrReportNumber ? formState.errors.cdrReportNumber.message : ''}
                            />
                        </div>
        
                        <Input
                            type="text"
                            label="CDR Report Number Year"
                            value={dayjs().year()}
                            disabled
                        />
                    </div>
                )}
            />

            <div className="flex justify-content-end align-item-center">
                <Button
                    type="submit"
                    disabled={!formState.isValid}
                    label={formState.isSubmitting ? "Saving Information..." : "Save Information"}
                />
            </div>
        </form>
     );
};
 
export default CDRReportNumberForm;